// extracted by mini-css-extract-plugin
module.exports = {"container":"_3sSyR___RawToggle-module__container","input":"_373Cd___RawToggle-module__input","label":"_39poq___RawToggle-module__label"};